module.exports = __webpack_public_path__ + "/images/logo-Iperbimbo-it.660d9be.jpg";